/**
 * Convert a Firestore field key into a human-readable label.
 *   property_name     → "Property Name"
 *   listingType       → "Listing Type"
 *   primary-photo-url → "Primary Photo Url"
 *   primaryPhotoURL   → "Primary Photo URL"
 *
 * Treats runs of capitals (URL, ID, GPS) as acronyms — preserved
 * unchanged so they read naturally.
 */
const ACRONYMS = new Set([
  "URL",
  "ID",
  "GPS",
  "SEO",
  "PDF",
  "FAQ",
  "API",
  "HOA",
  "USD",
  "PHP",
  "CCTV",
  "BIR",
]);

export function humanizeKey(key) {
  if (!key) return "";
  // First insert space boundaries:
  //   - underscores / hyphens → space
  //   - lowercase → Uppercase boundary  (camelCase → camel Case)
  //   - Run of capitals followed by lowercase  (URLPath → URL Path)
  const spaced = String(key)
    .replace(/[_-]+/g, " ")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    .replace(/\s+/g, " ")
    .trim();

  return spaced
    .split(" ")
    .map((word) => {
      const upper = word.toUpperCase();
      if (ACRONYMS.has(upper)) return upper;
      if (!word) return "";
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
}
